export default __webpack_public_path__ + "static/media/shower-icon-black.bc74098c.svg";